<template>
  <section class="col-12">
    <h2 class="text-center">{{$t('Pick your colors')}}</h2>
    <div class="product-soldat-container">
      <div class="color-selector-container">
        <hooper
          :settings="colorsSettings"
          @slide="updateColors"
          class="colors"
          tabindex="-1"
          ref="colors"
        >
          <slide
            v-for="(color, indx) in colors"
            :key="`${indx + color}-dial`"
            :index="indx"
          >
            <button
              type="button"
              class="color-swatch"
              :class="{ selected: currentStrapId == color.id }"
              @click="colorClicked(color.id)"
              :style="{ background: color.color }"
            ></button>
          </slide>
          <hooper-navigation slot="hooper-addons" :class="{'hide-navigation': colors.length <= 4, 'hide-desktop-navigation': colors.length <= 8 && colors.length > 4}"></hooper-navigation>
        </hooper>
      </div>
      <div class="tab-mobile">
        <div
          class="strap-item-container"
          :class="{ 'close-mobile': openWatches }"
        >
          <div class="strap-item-col">
            <strap-item
              :key="selectedStrap.id"
              is-config="true"
              :product="selectedStrap"
            ></strap-item>
          </div>
        </div>
        <button
          v-if="straps"
          type="button"
          class="show-watches"
          aria-controls="watches-modal"
          @click="openWatches = true"
        >
          <i class="icon-entretien"></i>
          <span>{{ $t('Try with a watch') }}</span>
        </button>

        <div
          class="watches-modal"
          id="watches-modal"
          :class="{ 'close-mobile': !openWatches }"
          v-if="
            straps && straps.dials && straps.dials.length > 0 && openWatches
          "
        >
          <hooper
            :settings="dialsSettings"
            ref="dials"
            @slide="updateDials"
            class="dials"
            tabindex="-1"
          >
            <slide
              v-for="(product, indx) in straps.dials"
              :key="`${indx}-dial`"
              :index="indx"
            >
              <button
                v-if="product.cadran"
                type="button"
                @click="watchClicked(product)"
              >
                <img :src="product.cadran" :alt="product.alt" />
              </button>
            </slide>
          </hooper>
          <div class="dials-navigation" v-if="straps.dials.length > 3">
            <button
              ref="prevButton"
              type="button"
              class="hooper-prev"
              :class="{ 'is-disabled': !currentDials }"
              :aria-label="$t('Previous slide')"
              @click="() => $refs.dials.slidePrev()"
            ></button>
            <button
              ref="nextButton"
              type="button"
              class="hooper-next"
              :class="{
                'is-disabled': currentDials >= straps.dials.length - 1
              }"
              :aria-label="$t('Next slide')"
              @click="() => $refs.dials.slideNext()"
            ></button>
          </div>
          <product-header-item :item="straps.dial"></product-header-item>
          <button
            type="button"
            class="show-watches"
            aria-controls="watches-modal"
            @click="openWatches = false"
          >
            <i class="icon-close"></i>
            <span>{{ $t('Back to strap view') }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ReadyHook } from 'vue-asyncready'
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper'

import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import SearchQuery from '@vue-storefront/core/lib/search/searchQuery'
import { quickSearchByQuery } from '@vue-storefront/core/lib/search'
import config from 'config'
import StrapItem from './StrapItem.vue'
import { getElasticProduct } from 'src/modules/prismic/store/actions'
import { isServer } from '@vue-storefront/core/helpers'

import { STRAP_SIZE_KEY, BUCKLE_KEY } from '../utilities'
import ProductHeaderItem from './ProductHeaderItem.vue'

const WATCH_CLINIC = 'Watch Clinic'

export default {
  mixins: [ReadyHook],
  name: 'color_selector',
  props: ['item'],
  components: {
    Hooper,
    Slide,
    ProductHeaderItem,
    StrapItem,
    HooperNavigation
  },
  data() {
    return {
      STRAP_SIZE_KEY,
      BUCKLE_KEY,
      resolvedRelatedProducts: [this.item.product],
      simpleProducts: { [STRAP_SIZE_KEY]: [], [BUCKLE_KEY]: [] },
      autoReady: false,
      currentSlide: 0,
      loadedSlides: [],
      callCenter: null,
      firstOption: null,
      secondOption: null,
      quantity: null,
      tooltipCn: false,
      reassurance: null,
      isSticky: false,
      isBottom: false,
      i18n: null,
      hooperSettings: {
        initialSlide: 0,
        transition: 600,
        playSpeed: 10000,
        autoPlay: true,
        mouseDrag: true,
        shortDrag: true,
        touchDrag: true,
        keysControl: true,
        wheelControl: false,
        hoverPause: false,
        infiniteScroll: true
      },
      dialsSettings: {
        wheelControl: false,
        itemsToShow: 3,
        itemsToSlide: 3,
        vertical: true
      },
      colorsSettings: {
        wheelControl: false,
        itemsToShow: 4,
        itemsToSlide: 1,
        breakpoints: {
          991: {
            vertical: true,
            itemsToShow: 8
          }
        }
      },
      loop: 0,
      availableModal: false,
      iconsModal: false,
      ecommerceActivated: undefined,
      strapSize: null,
      buckleType: null,
      strapPrice: 0,
      openWatches: false,
      straps: {
        dial: {},
        dials: []
      },
      currentDials: 0,
      currentColors: 0,
      currentStrapId: this.item.product.id,
      hasStrapSlider: true,
      selectedWatchClinicExperience: null,
      watchClinicAvailableDates: [],
      watchClinicDisabledDates: {},
      watchClinicAvailableTimes: [],
      watchClinicTimeSlots: {
        dates: [],
        availabilities: [],
        languages: {}
      },
      watchClinicExperiences: [],
      selectedEventTime: null,
      selectedEventDate: null,
      selectedMonth: { y: new Date().getFullYear(), m: new Date().getMonth() },
      breadCrumbItems: [],
      selectedStrap: this.item.product
    }
  },
  computed: {
    ...mapGetters('watch-memory', ['getWatch']),
    ...mapGetters('prismic', ['getPage']),
    strapsItem() {
      return [this.selectedStrap || this.item.product]
    },
    colors() {
      return this.resolvedRelatedProducts.map(product => ({
        color: product.colorCode,
        id: product.id
      }))
    },
    isWatchClinic() {
      return this.item.product.attribute_set_name === WATCH_CLINIC
    },
    localizedUrl() {
      return currentStoreView().url || ''
    },
    storeCode() {
      const { storeCode } = currentStoreView()
      return storeCode
    },
    soldat() {
      if (this.item.soldat) {
        return {
          src: this.item.soldat.src,
          alt: this.item.soldat.alt ? this.item.soldat.alt : '',
          soldat: !this.isWatchClinic,
          width: this.item.soldat.width,
          height: this.item.soldat.height
        }
      } else return null
    }
  },
  watch: {},
  methods: {
    ...mapActions('watch-memory', ['setValue']),
    keyup(e) {
      if (e.keyCode === 27) {
        this.openWatches = false
      }
    },
    convertImage(url) {
      return config.magento2.imgUrl + url
    },
    compareSize(a, b) {
      if (a.strap_min_length < b.strap_min_length) {
        return -1
      }
      if (a.strap_min_length > b.strap_min_length) {
        return 1
      }
      return 0
    },
    watchClicked(product) {
      this.straps.dial = product
      this.setValue({ watch: product.sku })
    },
    colorClicked(color) {
      if(this.$refs.dials){
        this.$refs.dials.slideTo(0);
      }
      this.currentStrapId = color
      const storeView = currentStoreView()
      getElasticProduct(this.currentStrapId, {size: 1})
        .then(raw => raw.product[storeView.storeCode])
        .then(fullStrap => {
          this.selectedStrap = fullStrap
          this.checkForStrap()
        })
    },
    updateDials(payload) {
      this.currentDials = payload.currentSlide
    },
    updateColors(payload) {
      this.currentColors = payload.currentSlide
    },
    getConcatImage(left, right, printPath = true) {
      let url =
        left.replace('.png', '') +
        '_' +
        right.replace('/', '.').toLowerCase() +
        '.png'
      return printPath ? this.convertImage(url) : url
    },
    checkForStrap() {
      // here check
      if (!this.item.product.main_category) {
        return
      }
      const toFind = 'Straps'
      const filtered = this.item.product.main_category.filter(el => {
        return el.name === toFind
      })
      if (filtered.length > 0) {
        this.straps = {
          dial: {},
          dials: []
        }
        this.straps.dials = this.selectedStrap.related_products
          .filter(product => !!product.dial_image)
          .map(product => ({
            sku: product.sku,
            cadran: product.dial_image
              ? this.convertImage(product.dial_image)
              : null,
            src: this.getConcatImage(product.image, this.item.product.sku),
            alt: product.name,
            soldat: true,
            width: '',
            height: ''
          }))
        this.straps.dial = this.straps.dials.find(
          element => element.sku === this.getWatch
        )
        if (!this.straps.dial) {
          this.straps.dial = this.straps.dials[0]
        }
      }
    },
    resize() {
      this.$refs.colors.slideTo(0);
      if (window.innerWidth < 991) {
        this.openWatches = false
      } else {
        this.openWatches = true
      }
    }
  },
  mounted() {
    // this.$el.querySelector('button, a').focus()
    document.addEventListener('keyup', this.keyup)
    this.hasStrapSlider = !!document.getElementById('additional_straps')
    window.addEventListener('resize', this.resize)
  },
  created() {
    const storeView = currentStoreView()
    // set color variations data
    if (this.item.product.colors_variations && this.item.product.colors_variations.length) {
      this.resolvedRelatedProducts = [this.item.product, ...this.item.product.colors_variations]
    }
    // set breadcrumb data
    quickSearchByQuery({
      query: {
        query: {
          bool: {
            filter: {
              bool: {
                must: [
                  { terms: { id: [this.item.product.category[0].category_id] } }
                ]
              }
            }
          }
        }
      },
      entityType: 'category',
      storeCode: storeView.storeCode,
      start: 0,
      size: 100
    }).then(result => {
      if (result.items && result.items[0]) {
        const parentCategoriesData = result.items[0].parents_data
        const lastCategoryData =
          parentCategoriesData[parentCategoriesData.length - 1]
        this.breadCrumbItems = [
          { name: lastCategoryData.name, url_key: lastCategoryData.id },
          { name: this.item.product.name }
        ]
      }
    })
    this.$ready()
    this.i18n = currentStoreView().i18n
    this.ecommerceActivated = this.$store.state['zenith-ui'].ecommerce
    this.checkForStrap()
  },
  destroyed: function() {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

@mixin arraowNext {
  &:before {
    display: block;
    content: '';
    position: absolute;
    top: 40%;
    left: 50%;
    width: 1.4rem;
    height: 1.4rem;
    border-right: 1px solid var(--zenith-theme-primary);
    border-bottom: 1px solid var(--zenith-theme-primary);
    transform: translate(-50%, -50%) rotate(45deg);
    transition: all 0.2s ease-in-out;

    @include bp(max md) {
      width: 1rem;
      height: 1rem;
    }
  }
  &.is-disabled {
    opacity: 0;
    pointer-events: none;
  }

  &:hover,
  &:focus {
    &:before {
      transform: translate(-50%, -50%) rotate(45deg) scale(1.2);
    }
  }
}
@mixin arraowPrev {
  &:before {
    display: block;
    content: '';
    position: absolute;
    top: 60%;
    left: 50%;
    width: 1.4rem;
    height: 1.4rem;
    border-left: 1px solid var(--zenith-theme-primary);
    border-top: 1px solid var(--zenith-theme-primary);
    transform: translate(-50%, -50%) rotate(45deg);
    transition: all 0.2s ease-in-out;

    @include bp(max md) {
      width: 1rem;
      height: 1rem;
    }
  }
  &.is-disabled {
    opacity: 0;
    pointer-events: none;
  }

  &:hover,
  &:focus {
    &:before {
      transform: translate(-50%, -50%) rotate(45deg) scale(1.2);
    }
  }
}

h2 {
  text-transform: uppercase;
}

.strap-item {
  &-container {
    position: relative;
    padding: 3rem;
    height: 100%;
  }
  &-col {
    position: relative;
    height: 100%;
  }
}

section.col-12 {
  background-color: var(--zenith-component-product-header-background);
  padding-top: 2.4rem;
  margin-top: 3.6rem;
}

.product-soldat-container {
  height: calc(100vh - 21rem);
  padding-bottom: 2rem;
  @include bp(md) {
    height: calc(100vh - 30rem);
  }

  .tab-mobile {
    position: relative;
    height: 90%;
    .strap-item-container {
      /deep/ .config-modal {
        z-index: 50;
      }
    }
  }

  @include bp(lg) {
    height: auto;
    // min-height: 60rem;
    display: grid;
    grid-template-columns: 1fr 3fr;
    .tab-mobile {
      display: flex;
      height: 100%;
      justify-content: center;
      .strap-item-container {
        width: 40%;
      }
      .watches-modal {
        width: 60%;
      }
    }
  }

  .close-mobile {
    display: none;
    @include bp(lg) {
      display: block;
    }
  }

  .color-selector-container {
    position: relative;
    height: 10%;
    text-align: center;
    display: flex;
    align-items: center;
    @include bp(lg) {
      height: 100%;
      padding: 4rem;
      display: block;
      /deep/ .hooper-list {
        display: grid;
      }
    }
    .colors {
      height: auto;

      &:not(.is-vertical){
        position: static;
        margin: 0 50px;
        overflow: hidden;
      }
      
      .hooper-navigation {

        &.hide-navigation{
          display: none;
        }

        &.hide-desktop-navigation{
          @include bp(lg) {
            display: none;
          }
        }
      }
      @mixin customArraowPosition {
        position: absolute;
        left: 0%;
        right: 0%;
      }
      @include bp(lg) {
        height: 100%;
        .hooper-navigation {
          /deep/ .hooper-prev {
            @include customArraowPosition;
            top: -3.3rem;
            svg {
              display: none;
            }
            @include arraowPrev;
          }
          /deep/ .hooper-next {
            @include customArraowPosition;
            bottom: -3.5rem;
            svg {
              display: none;
            }
            @include arraowNext;
          }
        }
      }
    }
    .color-swatch {
      height: 4rem;
      width: 4rem;
      border-radius: 50%;
      border: none;
      &.selected {
        border: solid 1px var(--zenith-theme-primary);
      }
    }
  }
}

.hooper {
  outline: none;
  height: calc(100vh - 21rem);

  @include bp(md) {
    height: calc(100vh - 30rem);
  }

  @include bp(lg) {
    height: 100%;
  }

  @include bp(xl) {
    height: 100%;
  }

  /deep/ .hooper-slide {
    position: relative;
    overflow: hidden;
  }

  & + .hooper-navigation {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
    display: none;

    @include bp(xl) {
      display: block;
    }

    .hooper-prev {
      left: 4rem;
      outline: none;

      &:before {
        content: '\e903';
      }

      &:hover {
        &:before {
          @include pillPrevHover();
        }
      }

      &.hidden-button {
        transform: translate(50%, -50%);
      }
    }

    .hooper-next {
      right: 4rem;
      outline: none;

      &:before {
        content: '\e925';
      }

      &:hover {
        &:before {
          @include pillNextHover();
        }
      }

      &.hidden-button {
        transform: translate(-50%, -50%);
      }
    }

    button {
      color: var(--zenith-component-slider-full-page-button);
      padding: 1.3rem;
      border-radius: 100%;
      box-shadow: 0 1px 1px 0
        var(--zenith-component-slider-full-page-button-shadow);
      border: 1px solid var(--zenith-component-slider-full-page-button);

      transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1),
        background 0.2s ease-in-out,
        opacity 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) 100ms;

      &.hidden-button {
        opacity: 0;
        transition: transform 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s,
          background 0.2s ease-in-out,
          opacity 0.3s cubic-bezier(0.39, 0.575, 0.565, 1);
      }

      svg {
        display: none;
      }

      &:before {
        display: block;
        font-family: 'zenith', sans-serif !important;
        speak: none;
        font-size: em(20);
        line-height: 2rem;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;

        /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }

      &.black-arrow {
        color: var(--zenith-component-product-header-arrow-first);
      }

      &.is-disabled {
        opacity: 0 !important;
        pointer-events: none;
      }

      &:hover,
      &:active {
        color: var(--zenith-component-slider-full-page-button-hover);
        background-color: var(
          --zenith-component-slider-full-page-button-hover-background
        );
        border-color: var(
          --zenith-component-slider-full-page-button-hover-border
        );
      }
    }
  }
}

/deep/ .hooper-sr-only {
  display: none;
}

.show-watches {
  position: absolute;
  bottom: 10rem;
  left: 10rem;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  text-align: center;
  color: var(--zenith-theme-primary);
  display: none;

  @include bp(max lg) {
    display: block;
    left: 2rem;
    bottom: 3rem;
  }

  i {
    display: block;
    font-size: em(30);
    width: 6rem;
    line-height: 5.8rem;
    text-align: center;
    color: var(--zenith-theme-primary);
    border: 1px solid var(--zenith-btn-disabled);
    margin: 0 auto;
    border-radius: 100%;
    transition: all 0.2s ease-in-out;

    @include bp(max md) {
      width: 4rem;
      line-height: 3.8rem;
      font-size: em(26);
    }
  }

  span {
    position: absolute;
    top: 120%;
    text-transform: uppercase;
    text-align: center;
    font-size: em(12);
    letter-spacing: em(0.5, 12);
    line-height: em(18, 12);
    left: 50%;
    width: 14rem;
    color: var(--zenith-theme-primary);
    transform: translateX(-50%);
    display: block;

    @include bp(max md) {
      display: none;
    }
  }

  &:hover,
  &:focus {
    i {
      color: var(--zenith-white);
      background: var(--zenith-theme-primary);
      border-color: var(--zenith-theme-primary);
    }
  }
}

.watches-modal {
  position: absolute;
  z-index: 10;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #f8f8f8;
  @include bp(lg) {
    position: relative;
  }

  .dials {
    position: absolute;
    z-index: 10;
    right: 0;
    bottom: 10%;
    width: 10rem;
    margin: 0;
    padding: 0;
    top: 10%;
    height: auto;
    background-color: transparent;

    /deep/ .hooper-track {
      height: auto;
    }

    button {
      height: 100%;
      border: none;
      width: 10rem;
      padding: 1rem 0;
      cursor: pointer;
      background: none;
      color: var(--zenith-theme-primary);

      /deep/ img {
        max-height: 100%;
        transform: scale(0.9);
        transition: all 0.2s ease-in-out;
      }

      &:hover,
      &:focus {
        /deep/ img {
          transform: scale(1);
        }
      }
    }

    &-navigation {
      position: absolute;
      bottom: 10%;
      right: 0;
      width: 10rem;
      top: 0;
      height: 100%;

      .hooper-prev {
        position: absolute;
        z-index: 10;
        top: 0;
        left: 0;
        width: 10rem;
        height: 4rem;
        padding: 0;
        transform: none;

        @include bp(max md) {
          width: 10rem;
        }

        @include arraowPrev;
      }

      .hooper-next {
        position: absolute;
        z-index: 10;
        top: auto;
        bottom: 0;
        left: 0;
        width: 10rem;
        height: 4rem;
        padding: 0;
        transform: none;

        @include bp(max md) {
          width: 10rem;
        }

        @include arraowNext;
      }
    }
  }

  /deep/ .product-header-item .product-header-item-image.soldat {
    left: calc(50% - 5rem);
  }
}
</style>
